<template>
  <YdDialog
    title="新增/编辑奖品"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="60%"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="140px"
    >
      <!-- <div class="title-box">基本信息</div> -->

      <el-form-item label="奖品类型" prop="type">
        <el-select
          :disabled="disabled"
          v-model="form.prizeType"
          placeholder="请选择"
          style="width: 300px"
          @change="prizeTypeChange"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="couponNameStr"
        prop="couponName"
        v-if="form.prizeType === 1 || form.prizeType === 5"
      >
        <el-input
          type="text"
          :placeholder="`选择${couponNameStr}`"
          v-model="form.couponName"
          disabled
          style="width: 300px"
        />
        <el-button :disabled="disabled" class="margin-left-10" @click="openSelectCoupon"
          >选择{{ couponNameStr }}</el-button
        >
      </el-form-item>

      <el-form-item label="奖品名称" prop="prizeName">
        <el-input
          type="text"
          placeholder="不超过10个字"
          v-model="form.prizeName"
          maxlength="10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>

      <el-form-item label="红包金额" prop="price" v-if="form.prizeType === 2">
        <el-input
          type="number"
          placeholder="不超过 200 元"
          v-model="form.price"
          :max="200"
          style="width: 300px"
          :disabled="disabled"
        />&nbsp;&nbsp;元
      </el-form-item>

      <el-form-item
        label="礼包/优惠券金额"
        prop="price"
        v-if="form.prizeType === 1 || form.prizeType === 5"
      >
        <el-input
          type="number"
          v-model="form.price"
          :max="200"
          style="width: 300px"
          disabled
        />&nbsp;&nbsp;金额/个
      </el-form-item>

      <el-form-item label="奖品图片" prop="prizeImage" required>
        <el-upload
          ref="uploadRef"
          :action="doUpload"
          :headers="headers"
          name="file"
          list-type="picture-card"
          :before-upload="(file) => handleBeforeUpload(file, 100, 100)"
          :on-success="
            (response, file, fileList) => {
              return uploadSuccess(response, file, fileList)
            }
          "
          :limit="1"
          :on-error="handleUploadError"
          :on-remove="handleRemove"
          :file-list="fileList"
          :show-file-list="true"
          style="width: 100%"
          :data="{ code: 'activity' }"
          :class="{ disabled: uploadDisabled }"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">建议上传图片尺寸100*100px，不超过500kb。</div>
        </el-upload>
      </el-form-item>
      <el-form-item
        v-if="
          (form.prizeType === 1 && form.couponName) || (form.prizeType === 5 && form.couponName)
        "
        label="剩余数量"
      >
        {{ form.count }}个
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>

    <!-- 选择优惠券 -->
    <select-coupon
      from="prize-pool"
      ref="selectCoupon"
      v-if="selectVisible"
      :title="selectTitle"
      :disable="true"
      :selectType="selectType"
      @getCouponItem="getCouponItem"
    />
  </YdDialog>
</template>

<script>
  import SelectCoupon from '../../components/sendcoupon/select-coupon.vue'
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { postPrizesAdd, postPrizesEdit } from '@/api/marketing/pirze-draw'
  // import dayjs from 'dayjs'
  import { isEmpty } from 'lodash-es'

  export default {
    components: {
      SelectCoupon
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        selectTitle: '添加优惠券',
        selectType: 1,
        selectVisible: false,
        typeList: [
          { value: 1, label: '优惠券' },
          { value: 2, label: '现金红包' },
          { value: 5, label: '礼包' }
        ],
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          prizeType: [{ required: true, message: '请选择奖品类型', trigger: 'blur' }],
          couponName: [{ required: true, message: '请选择礼包/优惠券', trigger: 'blur' }],
          prizeName: [{ required: true, message: '请输入奖品名称', trigger: 'change' }],
          price: [{ required: true, message: '请输入金额', trigger: 'blur' }],
          prizeImage: [{ required: true, message: '请上传奖品图片', trigger: 'blur' }]
        },
        uploadDisabled: false,
        couponItem: [],
        isEdit: false,
        isAddPersonTime: false,
        form: {},
        couponNameStr: ''
      }
    },

    mounted() {
      if (!isEmpty(this.formData)) {
        this.form = this.formData
        this.fileList = [{ url: this.form.prizeImage }]
        this.uploadDisabled = true
      } else {
        this.form.isEdit = true
      }
      // this.showVisible = this.visible
    },
    computed: {
      //  form(){
      // return this.formData
      //  },
      disabled() {
        if (!isEmpty(this.formData)) {
          return !this.form.isEdit
        }
        return false
      },
      showVisible() {
        return this.visible
      }
    },
    methods: {
      prizeTypeChange(e) {
        if (e === 1) {
          this.couponNameStr = '优惠券'
        } else if (e === 5) {
          this.couponNameStr = '礼包'
        }
        console.log(e)
      },
      selectClose() {
        this.selectVisible = false
      },
      // 上传失败
      handleUploadError() {
        this.$loading().close()
        this.$modal.msgError('上传失败，请重试')
        this.uploadDisabled = false
      },
      handleRemove(file, fileList) {
        this.form.prizeImage = ''
        this.uploadDisabled = false
      },

      uploadSuccess(res, file, fileList, type) {
        this.$loading().close()
        if (JSON.stringify(res.data) === '{}') {
          this.$message.warning({
            message: '请修改文件名后重新上传'
          })
          const index = this.$refs.uploadRef.uploadFiles.findIndex((e) => e.uid === file.uid)
          this.$refs.uploadRef.uploadFiles.splice(index, 1)
          this.uploadDisabled = false
          return
        }
        this.form.prizeImage = res.data.url
      },
      handleBeforeUpload(file, imgWidth, imgHeight) {
        return new Promise((resolve, reject) => {
          const uploadTypes = ['jpg', 'jpeg', 'png', 'gif']
          // 获取文件类型，确保正确变量名
          const filetype = file.name.replace(/.+\./, '').toLowerCase()

          // 检查文件类型
          if (!uploadTypes.includes(filetype)) {
            this.$message.warning({
              message: '请上传后缀名为jpg、jpeg、png、gif的附件'
            })
            reject(new Error('文件类型不符'))
            return
          }

          // 检查图片尺寸
          this.getImgSize(file).then((res) => {
            const { width, height } = res
            if (width !== imgWidth || height !== imgHeight) {
              this.$message.warning({
                message: '尺寸不符，请修改尺寸后重新上传！'
              })
              this.uploadDisabled = false
              reject(new Error('尺寸不符'))
              return
            }

            // 文件名修改逻辑
            const newFileName = `image-${Date.now()}.${filetype}`
            const newFile = new File([file], newFileName, { type: file.type })

            // 显示 loading 状态，禁用上传按钮
            this.$loading()
            this.uploadDisabled = true

            // 继续上传，传递修改后的文件对象
            resolve(newFile)
          })
        })
      },

      getImgSize(imgFile) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },

      getCouponItem(v) {
        if (v) {
          if (v.length > 1) {
            this.$message('只能选择一个礼包/优惠券')
            return
          }
          this.form.couponName = v[0].name
          this.form.couponId = v[0].id
          this.form.count = v[0].surplusNum
          this.$set(this.form, 'price', v[0].discountsMoney)
          // this.form.price = v[0].discountsMoney
        }
        this.selectVisible = false
      },
      openSelectCoupon() {
        this.selectVisible = true
        if (this.form.prizeType === 1) {
          this.selectType = 2
          this.selectTitle = '添加优惠券'
        } else {
          this.selectType = 1
          this.selectTitle = '添加礼包'
        }
        this.$nextTick(() => {
          this.$refs.selectCoupon.init()
        })
      },
      closeEdit() {
        this.showVisible = false
        this.$emit('close')
      },

      save() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (!this.form.isEdit) {
              this.$message.warning('奖品已被选用，活动开始后不可修改！')
              return
            }

            if (!this.form.prizeImage) {
              this.$message.warning('请上传奖品图片！')
              return
            }
            if (this.form.prizeType === 2 && this.form.price > 200) {
              this.$message.warning('请调整金额！')
              return
            }
            let res
            if (!this.form.id) {
              res = await postPrizesAdd(this.form)
            } else {
              res = await postPrizesEdit(this.form)
            }
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('close')
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
